<template>
  <div>
    <list
      row-key="StudentId"
      ref="list"
      unit="考勤员未点名"
      :page="false"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.getStudentAttendanceStat"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange" size="mini">
            <template v-for="(i,index) in terms">
              <el-option :key="index" :value="i.TermId" :label="i.TermName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            size="mini"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :style="isMB?'width:220px;':'width: 250px;'"
            value-format="yyyy/MM/dd"
            unlink-panels
            :editable="false"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" size="mini" @change="getClass" clearable>
            <template v-for="(i,index) in grades">
              <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.ClassId" size="mini" clearable>
            <template v-for="(i,index) in classes">
              <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="ClassName" label="班级" min-width="100px" />
        <el-table-column prop="Zx" label="自习">
          <template slot-scope="{row}">
            {{row.Zx>0?row.Zx:''}}
          </template>
        </el-table-column>
        <el-table-column prop="Zd" label="早读">
          <template slot-scope="{row}">
            {{row.Zd>0?row.Zd:''}}
          </template>
        </el-table-column>
        <el-table-column prop="Wl" label="晚练">
          <template slot-scope="{row}">
            {{row.Wl>0?row.Wl:''}}
          </template>
        </el-table-column>
        <el-table-column prop="Wx1" label="晚修1">
          <template slot-scope="{row}">
            {{row.Wx1>0?row.Wx1:''}}
          </template>
        </el-table-column>
        <el-table-column prop="Wx2" label="晚修2">
          <template slot-scope="{row}">
            {{row.Wx2>0?row.Wx2:''}}
          </template>
        </el-table-column>
        <el-table-column prop="Total" label="总计" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, exportDialog },
  computed: {
    dateRange: {
      get() {
        return [this.params.StartDate, this.params.EndDate];
      },
      set(value) {
        console.log(value);
        if (value) {
          this.params.StartDate = value[0];
          this.params.EndDate = value[1];
          this.$refs.list.initParams.StartDate = value[0];
          this.$refs.list.initParams.EndDate = value[1];
        }
      },
    },
  },
  data() {
    return {
      api: require("@/api/at/attendance").default,
      term_api: require("@/api/ed/term").default,
      section_api: require("@/api/ed/section").default,
      grade_api: require("@/api/ed/grade").default,
      class_api: require("@/api/ed/class").default,
      params: {
        // AttendanceDate: new Date(),
        // SectionNumber: null,
        StartDate: this.$commonJs.getToday(),
        EndDate: this.$commonJs.getToday(),
        GradeId: null,
        ClassId: null,
        TermId: null,
        // Normal: false,
      },
      terms: [], //学期列表
      sections: [], //课程节次列表
      grades: [], //年级列表
      classes: [], //班级列表
      isMB: this.$store.state.isMB
    };
  },
  methods: {
    begin() {
      this.getTerm();
      this.getGrade();
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams);
      this.api.exportStudentAttendanceStat(params).then(() => {
        loading.close();
      });
    },
    getTerm() {
      this.term_api.list().then((res) => {
        let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
        this.params.TermId = loginInfo.TermId;
        this.terms = res.Data;
        if (this.terms.length > 0) {
          if(!this.params.TermId) {
            this.params.TermId = this.terms[0].TermId;
          }
          this.$refs.list.initQueryParams.TermId = this.params.TermId;
          this.query();
        }
      });
    },
    termChange() {
      this.params.GradeId = null;
      this.params.ClassId = null;
      this.classes = [];
      this.query();
    },
    getGrade() {
      this.grade_api.list().then((res) => {
        this.grades = res.Data;
      });
    },
    getClass() {
      var params = { GradeId: this.params.GradeId, TermId: this.params.TermId };
      this.class_api.list(params).then((res) => {
        this.params.ClassId = null;
        this.classes = res.Data;
      });
    },
  },
};
</script>